import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

function ChangeEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      verifyEmailChange();
    }
  }, [token]);

  const verifyEmailChange = async () => {
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('https://trcsite.net/api/auth/verify-email-change', {
        token
      });

      setMessage(response.data.message);

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError(error.response?.data?.error || 'Email change verification failed');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <h1>Email Change Verification</h1>
            <p>Invalid verification link</p>
          </div>
          <div className="auth-error">
            The verification link is invalid or has expired.
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/login" className="auth-link">
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <h1>Email Change Verification</h1>
          <p>{loading ? 'Verifying your email change...' : 'Confirm your email change'}</p>
        </div>

        {loading && (
          <div className="auth-loading">
            <div className="loading-spinner"></div>
            <span>Verifying your email change request...</span>
          </div>
        )}

        {message && (
          <div className="auth-success">
            <div className="success-icon">✓</div>
            <div>
              <strong>Email Changed Successfully!</strong>
              <p>{message}</p>
              <p>Please log in again with your new email address.</p>
              <p>Redirecting to login...</p>
            </div>
          </div>
        )}

        {error && (
          <div className="auth-error">
            <div className="error-icon">✗</div>
            <div>
              <strong>Email Change Failed</strong>
              <p>{error}</p>
              <div style={{ textAlign: 'center', marginTop: '15px' }}>
                <Link to="/login" className="auth-link">
                  Back to Login
                </Link>
                <Link to="/profile" className="auth-link" style={{ marginLeft: '10px' }}>
                  Go to Profile
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChangeEmail;
